import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import { LanguageProvider } from './context/LanguageContext.tsx';
import { initWebVitalsTracker, trackAppError } from './utils/analytics.ts';
import { initGlobalProximityImageObserver } from './utils/proximityImageObserver.ts';
import './index.css';

// Initialize Web Vitals & Error Tracking from Day 1
initWebVitalsTracker();

// Initialize Global Proximity Image Observer (preloads images within 1200px before scrolling)
initGlobalProximityImageObserver();

if (typeof window !== 'undefined') {
  const handleChunkError = (err: any) => {
    const msg = String(err?.message || err || '');
    if (
      msg.includes('dynamically imported module') ||
      msg.includes('Failed to fetch') ||
      msg.includes('Loading chunk') ||
      msg.includes('error loading dynamically imported module')
    ) {
      const lastReload = parseInt(sessionStorage.getItem('chunk_reload_ts') || '0', 10);
      if (Date.now() - lastReload > 10000) {
        sessionStorage.setItem('chunk_reload_ts', Date.now().toString());
        window.location.reload();
      }
    }
  };

  window.addEventListener('vite:preloadError', (event) => {
    console.warn('Vite preload error detected, refreshing page...', event);
    handleChunkError(event);
  });

  window.addEventListener('error', (event) => {
    handleChunkError(event.error || event.message);
    trackAppError(event.error || event.message, 'window.onerror');
  });

  window.addEventListener('unhandledrejection', (event) => {
    handleChunkError(event.reason);
    trackAppError(event.reason || 'Unhandled Promise Rejection', 'unhandledrejection');
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </StrictMode>,
);
